<template>
  <div></div>
</template>
<script>


export default {
  name: 'Google',
  data() {
    return {
    }
  },
  mounted() {
    window.location.href = 'https://www.google.com'
  },
  methods: {

  }
}
</script>
